import EventsFallback from '../../../../lib/events_fallback';

namespace('IO.Views.Components.Rje.Api', function (exports) {
  exports.Configuration = class Configuration extends EventsFallback {
    constructor(...args) {
      super(...args);
      this.csrf = options.csrf;
    }

    apply(url) {
      var req = this._makePutRequest(url);

      req.done(_.bind(this._applyDoneCallback, this));
      req.fail(_.bind(this._applyFailCallback, this));
    }

    _applyDoneCallback(resp) {
      if (resp.statuscode === 0) {
        this.trigger('apply:success', resp);
      } else {
        this._applyFailCallback(resp);
      }
    }

    _applyFailCallback(resp) {
      if (arguments.length === 1) {
        this.trigger('apply:fail', resp);
      } else {
        this.trigger('apply:fail', {
          error: arguments[2],
        });
      }
    }

    validate(url) {
      var req = this._makePutRequest(url);

      req.done(_.bind(this._validateDoneCallback, this));
      req.fail(_.bind(this._validateFailCallback, this));
    }

    _validateDoneCallback(resp) {
      if (resp.statuscode === 0) {
        this.trigger('validate:success', resp);
      } else {
        this._validateFailCallback(resp);
      }
    }

    _validateFailCallback(resp) {
      if (arguments.length === 1) {
        this.trigger('validate:fail', resp);
      } else {
        this.trigger('validate:fail', {});
      }
    }

    summary(url) {
      var req = this._makePutRequest(url);

      req.done(_.bind(this._summaryDoneCallback, this));
      req.fail(_.bind(this._summaryFailCallback, this));
    }

    _summaryDoneCallback(resp) {
      if (resp.statuscode === 0) {
        this.trigger('summary:success', resp);
      } else {
        this._summaryFailCallback(resp);
      }
    }

    _summaryFailCallback(resp) {
      this.trigger('summary:fail', resp);
    }

    _makePutRequest(url) {
      return $.ajax({
        type: 'post',
        url: url,
        data: {
          _method: 'put',
          authenticity_token: this.csrf,
        },
      });
    }

    _makeGetRequest(url) {
      return $.ajax({
        url: url,
      });
    }
  };
});
